import type { AttendanceLocation, PositionEvidence } from "./types";

export function distanceMeters(a: { latitude: number; longitude: number }, b: { latitude: number; longitude: number }) {
  const toRad = (value: number) => value * Math.PI / 180;
  const radius = 6_371_000;
  const dLat = toRad(b.latitude - a.latitude);
  const dLon = toRad(b.longitude - a.longitude);
  const lat1 = toRad(a.latitude);
  const lat2 = toRad(b.latitude);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return 2 * radius * Math.asin(Math.sqrt(h));
}

export function nearestLocation(position: PositionEvidence, locations: AttendanceLocation[]) {
  const configured = locations.filter((location) => location.latitude !== null && location.longitude !== null);
  if (!configured.length) return null;
  return configured.map((location) => ({ location, distance: distanceMeters(position, { latitude: location.latitude!, longitude: location.longitude! }) })).sort((a, b) => a.distance - b.distance)[0];
}

export function getPosition(): Promise<PositionEvidence> {
  if (!navigator.geolocation) return Promise.reject(new Error("อุปกรณ์นี้ไม่รองรับ GPS"));
  return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(
    (position) => resolve({ latitude: position.coords.latitude, longitude: position.coords.longitude, accuracyMeters: position.coords.accuracy, clientTimestamp: new Date().toISOString() }),
    () => reject(new Error("ไม่สามารถอ่าน GPS ได้ กรุณาอนุญาตตำแหน่งและลองอีกครั้ง")),
    { enableHighAccuracy: true, timeout: 15_000, maximumAge: 0 },
  ));
}
